var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{ref:"Header"}),_c('img',{staticClass:"Big-title",attrs:{"src":_vm.menuPic}}),_c('div',{staticClass:"container"},[_c('div',{staticClass:"about-list",domProps:{"innerHTML":_vm._s(_vm.content)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }